
<template>
  <div id="paginaAllestimenti">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Allestimenti</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist
                  id="dropStagioni"
                  ref="dropStagioni"
                  :query="queryStagioni"
                  :dataSource="stagioniData"
                  :index="stagioniIndex"
                  :fields="stagioniFields"
                  :change="onStagioneChange"
                  v-model="stagioneCorrente"
                  placeholder="Seleziona un Anno"
                ></ejs-dropdownlist>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist
                  id="dropSpettacoli"
                  ref="dropSpettacoli"
                  :query="querySpettacoli"
                  :dataSource="elencoSpettacoliList"
                  :index="spettacoliIndex"
                  :fields="elencoSpettacoliFields"
                  :enabled="dropSpettacoliEnabled"
                  :change="onSpettacoloChange"
                  v-model="spettacoloCorrente"
                  placeholder="Seleziona uno Spettacolo"
                  :allowFiltering="true"
                  :filtering="spettacoloFiltering"
                ></ejs-dropdownlist>
              </b-col>
              <b-col xl="12" md="12" class="pt-1 text-center" v-show="loading">
                <b-spinner label="Loading..."></b-spinner>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">
                <div id="GridParent">
                  <ejs-grid
                    id="gridA"
                    ref="gridA"
                    :dataSource="allestimentiFullData"
                    :allowSorting="true"
                    :toolbarClick="gridAClickHandler"
                    :toolbar="gridA.toolbarOptions"
                    :height="gridA.height"
                    :allowFiltering="true"
                    :filterSettings="gridA.filterOptions"
                    :editSettings="gridA.editOptions"
                    :actionBegin="gridAactionBegin"
                    :actionComplete="gridAactionComplete"
                    :allowGrouping="true"
                    :groupSettings="gridA.groupOptions"
                  >
                    <e-columns>
                      <e-column field="id" headerText="ID" :isPrimaryKey="true" width="50"></e-column>
                      <e-column field="descrizione" headerText="Descrizione" width="200"></e-column>
                      <e-column
                        field="fornitore" headerText="Denominazione" width="200"
                        foreignKeyField="id" foreignKeyValue="denominazione"
                        :dataSource="this.fornitoriList"
                      ></e-column>
                      <e-column
                        field="categoria" headerText="Categoria" width="100"
                        foreignKeyField="id" foreignKeyValue="label" :dataSource="this.allestimentiCategoriaList"
                      ></e-column>
                      <e-column field="importo" headerText="Importo" width="100" ></e-column>
                      <e-column field="note" headerText="Note" width="300" ></e-column>
                      <e-column field="pagato" headerText="Pagato" width="200"></e-column>
                    </e-columns>
                    <e-aggregates>
                      <e-aggregate>
                        <e-columns>
                          <e-column
                            type="Sum"
                            field="importo"
                            format="Tot € ######.##"
                          ></e-column>
                        </e-columns>
                      </e-aggregate>
                    </e-aggregates>
                  </ejs-grid>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <!-- Button:  -->
              <b-col xl="4" md="4" class="pt-1">
                <ejs-button id="downloadAnnoButton" cssClass="e-flat" @click.native="downloadXlsStagione()">Scarica Excel Stagione</ejs-button>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-button id="downloadExcel" ref="downloadExcel" @click.native="downloadXls()" disabled="true">Scarica Excel</ejs-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- dialogA1: dialogDettaglioAllestimento ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog
      id="dialogA1"
      ref="dialogA1"
      :header="dialogA1.header"
      :buttons="dialogA1.buttons"
      :visible="dialogA1.visible"
      :showCloseIcon="dialogA1.showCloseIcon"
      :close="dialogA1Close"
      :open="dialogA1Open"
      :zIndex="dialogA1.zIndex"
      :animationSettings="dialogA1.animationSettings"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogA1" v-model="dialogA1.tabAdialogA1Index">
        <b-tab title="Allestimenti" @click="tabClicked('dialogA1Tab01')">
          <b-row class="match-height">
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Allestimento</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="id" class="h5">ID</label>
                      <ejs-textbox
                        id="id"
                        v-model="allestimentiActiveData.id"
                        floatLabelType="Never"
                        cssClass=""
                        type="text"
                        autocomplete="false"
                        :readonly="true"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="spettacolo" class="h5">Spettacolo</label>
                      <ejs-dropdownlist
                        id="spettacolo"
                        v-model="allestimentiActiveData.spettacolo"
                        :dataSource="elencoSpettacoliList"
                        :fields="elencoSpettacoliFields"
                        placeholder="Selezione Spettacolo"
                        :readonly="true"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="categoria" class="h5">Categoria</label>
                      <ejs-dropdownlist
                        id="categoria"
                        ref="categoria"
                        v-model="allestimentiActiveData.categoria"
                        :dataSource="allestimentiCategoriaList"
                        :fields="allestimentiCategoriaFields"
                        :allowFiltering="true"
                        :filtering="categoriaFiltering"
                        placeholder="Selezione Categoria"
                        :change="onCategoriaChange"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="descrizione" class="h5">Descrizione</label>
                      <ejs-textbox
                        id="descrizione"
                        v-model="allestimentiActiveData.descrizione"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Descrizione"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="fornitore" class="h5">Fornitore</label>
                      <ejs-dropdownlist
                        id="fornitore"
                        v-model="allestimentiActiveData.fornitore"
                        :dataSource="fornitoriList"
                        :fields="fornitoriFields"
                        :allowFiltering="true"
                        :filtering="fornitoriFiltering"
                        :itemTemplate="itemTemplate"
                        :valueTemplate="valueTemplate"
                        placeholder="Selezione fornitore"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="importo" class="h5">Importo</label>
                      <ejs-numerictextbox
                        id="importo"
                        v-model="allestimentiActiveData.importo"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Importo"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="percentualeCompetenza" class="h5">Percentuale Competenza</label>
                      <ejs-numerictextbox
                        id="percentualeCompetenza"
                        v-model="allestimentiActiveData.percentualeCompetenza"
                        cssClass=""
                        format="###.##"
                        strictMode="true"
                        :min="minPerc"
                        :max="maxPerc"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="note" class="h5">Note</label>
                      <ejs-textbox
                        id="note"
                        v-model="allestimentiActiveData.note"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="note"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="dataCompetenza" class="h5">Data Competenza</label>
                      <ejs-datepicker
                        id="dataCompetenza"
                        ref="dataCompetenza"
                        v-model="allestimentiActiveData.dataCompetenza"
                        :format="settings.formatoData"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                        :change="onDataCompetenzaChange"
                      />
                    </b-col>                    
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="delayPagamento" class="h5">Scadenza Pagamento</label>
                      <ejs-dropdownlist
                        id="delayPagamento"
                        ref="delayPagamento"
                        :dataSource="delayPagamentoList"
                        :fields="delayPagamentoFields"
                        :change="onDelayPagamentoChange"
                        :value="60"
                        showClearButton="true"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="dataScadenzaPagamento" class="h5">Data Scadenza Pagamento</label>
                      <ejs-datepicker
                        id="dataScadenzaPagamento"
                        ref="dataScadenzaPagamento"
                        v-model="allestimentiActiveData.dataScadenzaPagamento"
                        :format="settings.formatoData"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="pagato" class="h5">Pagato</label>
                      <ejs-dropdownlist
                        id="pagato"
                        ref="pagato"
                        v-model="allestimentiActiveData.pagato"
                        :dataSource="pagatoList"
                        :fields="pagatoFields"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="dataPagamentoPrevista" class="h5">Data Pagamento Prevista</label>
                      <ejs-datepicker
                        id="dataPagamentoPrevista"
                        v-model="allestimentiActiveData.dataPagamentoPrevista"
                        :format="settings.formatoData"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="dataPagamento" class="h5">Data Pagamento</label>
                      <ejs-datepicker
                        id="dataPagamento"
                        ref="dataPagamento"
                        v-model="allestimentiActiveData.dataPagamento"
                        :format="settings.formatoData"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="riferimentoContabile" class="h5"
                        >Riferimento Contabile</label
                      >
                      <ejs-textbox
                        id="riferimentoContabile"
                        v-model="allestimentiActiveData.riferimentoContabile"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="riferimentoContabile"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="noteContabili" class="h5"
                        >Note Contabili</label
                      >
                      <ejs-textbox
                        id="noteContabili"
                        v-model="allestimentiActiveData.noteContabili"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="noteContabili"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="importoConsuntivo" class="h5">Importo Consuntivo</label>
                      <ejs-numerictextbox
                        id="importoConsuntivo"
                        v-model="allestimentiActiveData.importoConsuntivo"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Importo Consuntivo"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="numRegistrContabile" class="h5">Numero Registrazione Contabile</label>
                      <ejs-textbox
                        id="numRegistrContabile"
                        v-model="allestimentiActiveData.numRegistrContabile"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="numRegistrContabile"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="contoContabile" class="h5">Conto Contabile</label>
                      <ejs-textbox
                        id="contoContabile"
                        ref="contoContabile"
                        v-model="allestimentiActiveData.contoContabile"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="contoContabile"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="descrContoContabile" class="h5">Descrizione Conto Contabile</label>
                      <ejs-textbox
                        id="descrContoContabile"
                        v-model="allestimentiActiveData.descrContoContabile"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="descrContoContabile"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>



                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  LinkPlugin,
  AlertPlugin,
  ProgressPlugin,
  ToastPlugin,
  SpinnerPlugin,
} from "bootstrap-vue";
// import Vuexy
// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { Query } from "@syncfusion/ej2-data";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
} from "@syncfusion/ej2-vue-inputs";
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  Aggregate,
  Group,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

const axios = require("axios");
// use bootstrap-vue
Vue.use(LayoutPlugin);
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(DropdownPlugin);
Vue.use(DatePickerPlugin);
Vue.use(ButtonPlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ProgressPlugin);
Vue.use(ToastPlugin);
Vue.use(SpinnerPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
enableRipple(true);
// api
const apiVueEndPoint = process.env.VUE_APP_API_ENDPOINT;
const apiAllestimentiUrl = "/demo/api/allestimento";
const apiAllestimentoRicercaUrl = "/demo/api/allestimento/ricerca";
const apiAllestimentoExportXlsUrl = "/demo/api/allestimento/export_xls";
const apiAllestimentoExportXlsStagioneUrl = "/demo/api/allestimento/export_xls_stagione";
const apiSpettacoloUrl = "/demo/api/spettacolo";
// TODO: uso api vecchia
const apiRuoliUrl = "/api/personalespettacolo/ruoli";
const apiFornitoriUrl = "/demo/api/soggetto/fornitori";

var itemVue = Vue.component("itemTemplate", {
  template: `<span><span class='ragioneSociale'>{{data.ragioneSociale}}</span><span style='margin-right:3em;display:inline-block;'>&nbsp;&nbsp;</span><span class ='partitaIva'>{{data.partitaIva}}</span></span>`,
  data() {
    return {
      data: {},
    };
  },
});

export default Vue.extend({
  components: {},
  data() {
    return {
      minPerc: 0,
      maxPerc: 100,
      loading: false,
      // per gestione stagioni
      stagioniData: [
        { label: "Anno 2022", val: "2022" },
        { label: "Anno 2023", val: "2023" },
        { label: "Anno 2024", val: "2024" },
        { label: "Anno 2025", val: "2025" },
        { label: "Anno 2026", val: "2026" },
      ],
      stagioniFields: { value: "val", text: "label" },
      stagioniIndex: -1,
      queryStagioni: null,
      stagioneCorrente: null,
      // per gestione spettacoli
      elencoSpettacoliList: [],
      elencoSpettacoliFields: { value: "id", text: "titolo" },
      spettacoliIndex: -1,
      dropSpettacoliEnabled: false,
      querySpettacoli: null,
      spettacoloCorrente: null,
      // gestione elementi nascosti
      nonMostrare: false,
      itemTemplate: function () {
        return { template: itemVue };
      },
      valueTemplate: function () {
        return { template: itemVue };
      },

      // generali
      settings: {
        formatoData: "dd-MM-yyyy",
        formatoOra: "HH:mm",
        intervalloOra: 15,
        firstDayOfWeek: 1,
      },
      // allestimenti
      allestimentiFullData: [], // elenco completo dati allestimenti
      allestimentiActiveId: 0, // Id allestimento attivo (0 se nuovo)
      allestimentiActiveData: {}, // dati completi dell allestimento attivo
      allestimentiSavedData: {}, // dati completi dell allestimento attivo
      allestimentiDefaultData: {}, // dati completi di default per nuovi allestimenti
      allestimentiRuoliList: [], // elenco dei ruoli che un allestimento può ricoprire
      allestimentiRuoliFields: { text: "ruolo", value: "id" }, // specifica i campi da estrarre per popolare la lista dei ruoli
      allestimentiNazionalitaList: [], // elenco delle nazionalità che un allestimento può assumere
      allestimentiNazionalitaFields: { text: "naz", value: "id" }, // specifica i campi da estrarre per popolare la lista della nazionalità
      allestimentiDocFields: { text: "nomeInLista", value: "id" }, // specifica i campi da estrarre per popolare la lista dei documenti allestimento
      allestimentiCategoriaList: [
        { label: "Alloggio", id: "alloggio" },
        { label: "Altro", id: "altro" },
        { label: "Attrezzeria", id: "attrezzeria" },
        { label: "Calzature", id: "calzature" },
        { label: "Catering", id: "catering" },
        { label: "Costumi", id: "costumi" },
        { label: "Legname", id: "legname" },
        { label: "Luci", id: "luci" },
        { label: "Maschere", id: "maschere" },
        { label: "Materiale Elettrico", id: "materialeElettrico" },
        { label: "Materiale Musicale", id: "materialeMusicale" },
        { label: "Materiale di Consumo", id: "materialeConsumo" },
        { label: "Noleggi Tecnici", id: "noleggiTecnici" },
        { label: "Parrucco", id: "parrucco" },  
        { label: "Pitture", id: "pitture" },
        { label: "Scenografie", id: "scenografie" },
        { label: "SIAE", id: "siae" },
        { label: "Tintoria", id: "tintoria" },
        { label: "Trasporti e Facchini", id: "trasportiFacchini" },
        { label: "Trucco", id: "trucco" },
        { label: "Vigili del Fuoco", id: "vigiliDelFuoco" },
        { label: "Vitto", id: "vitto" },
        { label: "Spese viaggio artisti", id: "spese_viaggio_artisti" },
        { label: "Spese viaggio collaboratori esterni", id: "spese_viaggio_collaboratori" },
        { label: "Spese viaggio dipendenti", id: "spese_viaggio_dipendenti" },
        { label: "Noleggio luci", id: "noleggio_luci" },
        { label: "Noleggio materiale musicale", id: "noleggio_materiale_musicale" },
        { label: "Trasporti materiali", id: "trasporti_materiali" },
        { label: "Facchinaggio", id: "facchinaggio" },
        { label: "Accordatura pianoforte", id: "accordatura_pianoforte" },
        { label: "Tecnici (no assunzione)", id: "tecnici_no_assunzione" },
        { label: "Noleggi automezzi settore tecnico", id: "noleggi_automezzi_tecnico" },
        { label: "Noleggi automezzi per masse artistiche", id: "noleggi_automezzi_masse_artistiche" },
        { label: "Carburante", id: "carburante" },
        { label: "Coprodzioni", id: "coproduzioni" },
        { label: "Noleggio scene, costumi, parrucche, calzature", id: "noleggio_scene_costumi" },
        { label: "Pulizie", id: "pulizie" },
      ], // elenco delle Categorie
      allestimentiCategoriaFields: { text: "label", value: "id" }, // specifica i campi da estrarre per popolare la lista della Categoria


      // fornitori
      fornitoriList: [],
      fornitoriFields: { text: "ragioneSociale", value: "id" },

      oldDelay: null,
      delayPagamentoList: [
        { label: '30gg', value: 30 },
        { label: '60gg', value: 60 },
        { label: '90gg', value: 90 },
      ],
      delayPagamentoFields: { text: "label", value: "value" },
      // pagato
      pagatoList: [
        { label: "Si", id: "si" },
        { label: "No", id: "no" },
        { label: "Acconto", id: "acconto" },
      ],
      pagatoFields: { text: "label", value: "id" },

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA1
      dialogA1: {
        header: "",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogA1Ok,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogA1Cancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FadeZoom", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogA1Index: 0,
      },
      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: true,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuovo",
            tooltipText: "Inserisci nuovo allestimento",
            prefixIcon: "e-plus",
            id: "new",
          },
          {
            text: "Modifica",
            tooltipText: "Modifica allestimento",
            prefixIcon: "e-expand",
            id: "edit",
          },
          {
            text: "Cancella",
            tooltipText: "Cancella allestimento",
            prefixIcon: "e-cancel",
            id: "delete",
          },
          "Search",
        ],
        groupOptions: { showDropArea: false, columns: ["categoria"] },
      }, //
    };
  },
  created() {
    // log
    console.log("Pagina Allestimenti Creata");
    // inizializzazione elenchi dal backend
    // chiamate API

    // TODO gestione status 401 con redirect a login
    if (localStorage.getItem("userData") !== null) {
      // allestimentiNazionalità e allestimentiRuoli
      console.log("Recupero elenchi dal backend");
      useJwt.get(apiRuoliUrl).then((d) => {
        this.allestimentiNazionalitaList = d.data.nazionalita;
        // allestimentiRuoliList
        this.allestimentiRuoliList = d.data.ruoli;
      });

      // allestimentiFullData
      // recupero elenco allestimenti dal backend
      console.log("Recupero elenco allestimenti dal backend");
      useJwt.get(apiSpettacoloUrl).then((d) => {
        if (d.status != 200) {
          console.log("REDIRIGERE A LOGIN");
          alert("Effettua di nuovo il login");
        } else {
          // console.log("Elenco Spettacoli");
          // console.log(d.data);
          this.elencoSpettacoliList = d.data;
        }
      });

      // fornitori
      useJwt.get(apiFornitoriUrl).then((d) => {
        if (d.status != 200) {
          console.log("REDIRIGERE A LOGIN");
          alert("Effettua di nuovo il login");
        } else {
          // console.log(d.status);
          // console.log(d.data)
          this.fornitoriList = d.data
        }
      });
    } else {
      console.log("Non trovo UserData, prova ancora");
    }
  },
  mounted() {
    // disabilito gridA
    this.$refs.gridA.$el.classList.add("disablegrid");
    document.getElementById("GridParent").classList.add("wrapper");
    // focus su dropStagioni
    this.$refs.dropStagioni.ej2Instances.focusIn();
  },

  provide: {
    // per grid
    grid: [
      GridToolbar,
      GridSort,
      GridFilter,
      GridEdit,
      ForeignKey,
      Group,
      Aggregate,
    ],
  },
  methods: {
    spettacoloFiltering: function (e) {
      var searchData = this.elencoSpettacoliList;
      var query = this.querySpettacoli.clone();
      if (e.text != "") {
        query = query.where("titolo", "contains", e.text, true);
      }
      // console.log(query);
      // console.log(query.queries);
      e.updateData(searchData, query);
    },
    fornitoriFiltering: function (e) {
      var searchData = this.fornitoriList;
      var query = new Query();
      query =
        e.text != ""
          ? query.where("ragioneSociale", "contains", e.text, true)
          : query;
      e.updateData(searchData, query);
    },
    // categoriaFiltering
    categoriaFiltering: function (e) {
      var searchData = this.allestimentiCategoriaList;
      var query = new Query();
      query =
        e.text != "" ? query.where("label", "contains", e.text, true) : query;
      e.updateData(searchData, query);
    },
    // per dropdownlist combinate
    onStagioneChange: function (e) {
      this.querySpettacoli = new Query().where(
        "stagione",
        "equal",
        this.$refs.dropStagioni.ej2Instances.value
      );
      this.dropSpettacoliEnabled = true;
    },
    onSpettacoloChange: function (e) {
      // Inserire la chiamata per popolare la gridA e aggiornare il titolo di "Elenco Allestimenti" e sottotitolo
      this.loading = true;
      console.log("Recupero elenco allestimenti dal backend");
      const datiDaInviare = {
        spettacolo: this.spettacoloCorrente,
      };
      if (datiDaInviare.spettacolo === null) {
        console.log("Spettacolo non ancora selezionato");
      } else {
        useJwt.post(apiAllestimentoRicercaUrl, datiDaInviare).then((d) => {
          // gestione risposta
          this.allestimentiFullData = d.data;
          // console.log("Elenco allestimenti collegati");
          // console.log(this.allestimentiFullData);

          this.loading = false;
        });
      }
      // aggiornare id spettacolo usato in dialog
      this.allestimentiActiveData.spettacolo = this.spettacoloCorrente;
      // abilito gridA
      this.$refs.gridA.$el.classList.remove("disablegrid");
      this.$refs.downloadExcel.ej2Instances.disabled=false;
      document.getElementById("GridParent").classList.remove("wrapper");
    },
    onDataCompetenzaChange: function(e) {
      let delay = this.$refs.delayPagamento.ej2Instances.value
      let dataCompetenzaAttuale = this.$refs.dataCompetenza.ej2Instances.value
      var p = new Date(dataCompetenzaAttuale)
      p.setDate(p.getDate() + delay)
      this.allestimentiActiveData.dataScadenzaPagamento = p
      this.allestimentiActiveData.dataPagamentoPrevista = p 
    },
    onDelayPagamentoChange: function() {
      console.log("NUOVO VALORE DELAY PAGAMENTO")
        let delay = this.$refs.delayPagamento.ej2Instances.value
        let dataScadenzaPagamentoAttuale = this.$refs.dataScadenzaPagamento.ej2Instances.value
        if (dataScadenzaPagamentoAttuale == null) {
            var p = new Date()
            p.setHours(0, 30, 0)
        } else {
            var p = new Date(this.$refs.dataScadenzaPagamento.ej2Instances.value)
        }
        console.log(this.$refs.dataScadenzaPagamento.ej2Instances.value)
        console.log("data scadenza pagamento attuale")
        console.log(p)
        if (this.oldDelay != null) {
            p.setDate(p.getDate() - this.oldDelay)
        }
      p.setDate(p.getDate() + delay)
      this.oldDelay = delay
      this.allestimentiActiveData.dataScadenzaPagamento = p
      console.log("data scadenza pagamento aggiornata")
      console.log(p)
    },

               
      onCategoriaChange: function (e) {
        const mapping_categorie = {
          'spese_viaggio_artisti': {conto: '6017000015', descr: "VITTO E ALLOGGIO ARTISTI"},
          'spese_viaggio_collaboratori': {conto: '6015004150', descr: "SPESE DI VIAGGIO COLLABORATORI ESTERNI"},
          'spese_viaggio_dipendenti': {conto: '6014000851', descr: "SPESE DI VIAGGIO E TRASFERTA DIPENDENTI"},
          'attrezzeria': {conto: '6017000001', descr: "SCENE"},
          'calzature': {conto: '6017000002', descr: "COSTUMI"},
          'costumi': {conto: '6017000002', descr: "COSTUMI"},
          'catering': {conto: '6015004750', descr: "SERVIZI DIVERSI"}, 
          'legname': {conto: '6005000050', descr: "ACQUISTI MATERIALI PER SCENE"}, 
          'noleggio_luci': {conto: '6017000006', descr: "NOLEGGIO MATERIALE TECNICO"}, 
          'maschere': {conto: '6015002962', descr: "SERVIZI DI TERZI"},
          'materialeMusicale': {conto: '6017000027', descr: "ACQUISTO MATERIALE MUSICALE"},
          'noleggio_materiale_musicale': {conto: '6017000014', descr: 'NOLO PARTITURE'},
          'materialeConsumo': {conto: '6005000150', descr: 'ACQUISTI MATERIALE DI CONSUMO'},
          'noleggiTecnici': {conto: '6017000006', descr: 'NOLEGGIO MATERIALE TECNICO'},
          'parrucco': {conto: '6017000002', descr: 'COSTUMI'},
          'pitture': {conto: '6005000050', descr: 'ACQUISTI MATERIALI PER SCENE'},
          'scenografie': {conto: '6017000001', descr: "SCENE"},
          'siae': {conto: '7820006750', descr: "DIRITTI SIAE"},
          'tintoria': {conto: '6017000002', descr: 'COSTUMI'},
          'trasporti_materiali': {conto: '6017000007', descr: 'TRASPORTI'},
          'facchinaggio': {conto: '6015002962', descr: 'SERVIZI DI TERZI'},
          'trucco': {conto: '6017000002', descr: 'COSTUMI'},
          'vigiliDelFuoco': {conto: '6015000510', descr: 'SERVIZI DI VIGILANZA ANTINCENDIO'},
          'accordatura_pianoforte': {conto: '6017000008', descr: 'COLLABORATORI PROFESSIONISTI TECNICI'},
          'tecnici_no_assunzione': {conto: '6017000008', descr: 'COLLABORATORI PROFESSIONISTI TECNICI'},
          'noleggi_automezzi_tecnico': {conto: '6020001290', descr: 'NOLEGGIO AUTOMEZZI'},
          'noleggi_automezzi_masse_artistiche': {conto: '6015004150', descr: "SPESE DI VIAGGIO COLLABORATORI ESTERNI"},
          'carburante': {conto: '6005000650', descr: 'CARBURANTI E LUBRIFICANTI PER MEZZI DI TRASPORTO'},
          'coproduzioni': {conto: '6017000022', descr: 'COPRODUZIONI'},
          'noleggio_scene_costumi': {conto: '6017000005', descr: 'NOLEGGIO SCENE E COSTUMI'},
          'pulizie': {conto: '6015002100', descr: 'SERVIZI DI PULIZIA'},
        }

        const cat = this.$refs.categoria.ej2Instances.value
        if (cat in mapping_categorie) {
          const val = mapping_categorie[cat]
          this.allestimentiActiveData.contoContabile = val.conto;
          this.allestimentiActiveData.descrContoContabile = val.descr;
        } else {
          console.log("chiave manca");
        }

    },
    downloadXls: function() {
      const datiDaInviare = { spettacolo: this.spettacoloCorrente, }
      useJwt.post(apiAllestimentoExportXlsUrl, datiDaInviare, { responseType: "blob" }).then((r) => {
        let fileName = r.headers["content-disposition"].split("filename=")[1];
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      }).catch((r) => {
        this.makeToast("primary", "FAILURE", "Errore stagione non selezionata")
      });
    },
    downloadXlsStagione: function() {
      const datiDaInviare = { stagione: this.stagioneCorrente }
      useJwt.post(apiAllestimentoExportXlsStagioneUrl, datiDaInviare, { responseType: "blob" }).then((r) => {
        let fileName = r.headers["content-disposition"].split("filename=")[1];
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      }).catch((r) => {
        this.makeToast("primary", "FAILURE", "Errore stagione non selezionata")
      });
    },

    // per dialogA1
    dialogA1OpenButtonClick() {
      this.$refs.dialogA1.show(true);
    },
    dialogA1Open(args) {
      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();

      console.log("Apertura dialogA1");
      // assegnare le informazioni da visualizzare nel dialog A
      console.log("allestimento attivo");
      console.log(this.allestimentiActiveId);

      this.allestimentiSavedData = { ...this.allestimentiActiveData };
      if (this.allestimentiActiveId == 0) {
        console.log("set dropdown")
        this.allestimentiActiveData.pagato = "no";
        this.$refs.pagato.ej2Instances.value = "no";
        this.$refs.pagato.ej2Instances.refresh();
      }
    },
    dialogA1Close() {
      console.log("Chiusura dialogA1");
      this.dialogA1.tabAdialogA1Index = 0;
      this.allestimentiActiveData.documenti = [];
    },
    validazioneDati() {
      console.log(this.allestimentiActiveData.dataScadenzaPagamento)
      console.log(this.allestimentiActiveData.fornitore)
      if (!this.allestimentiActiveData.dataScadenzaPagamento) {
        this.makeToast("primary", "ERRORE", "Richiesto valore data scadenza pagamento")
        return false
      }
      if (!this.allestimentiActiveData.fornitore) {
        this.makeToast("primary", "ERRORE", "Richiesta selezione soggetto fornitore")
        return false
      }

      return true
    },
    dialogA1Ok() {
      console.log("Cliccato bottone OK di dialogA1");

      if (!this.validazioneDati()) {
        return; // esco se fallisce validazione
      }
      if (this.allestimentiActiveId === 0) {
        // salvataggio in caso di new
        useJwt
          .post(apiAllestimentiUrl, this.allestimentiActiveData)
          .then((res) => {
            if (res.status == 200 || res.status == 201) {
              this.makeToast(
      "primary",
      "Successo",
      "Creazione dell'allestimento"
              );
            }
            console.log(res.status);
            console.log(res.data);
            // mi segno ID elemento appena creato
            this.allestimentiActiveId = res.data.id;
            return this; // restituisci contesto per permettere aggiornamento gridA
          })
          .then((context) => {
            const datiDaInviare = {
              spettacolo: this.spettacoloCorrente,
            };
            if (datiDaInviare.spettacolo === null) {
              console.log("Spettacolo non ancora selezionato");
            } else {
              useJwt
                .post(apiAllestimentoRicercaUrl, datiDaInviare)
                .then((d) => {
                  // gestione risposta
                  console.log(
              "Aggiornamento gridA con l'aggiunta di una scrittura"
                  );
                  console.log(d.data);
                  context.allestimentiFullData = d.data;
                  context.allestimentiFullData = [
                    ...context.allestimentiFullData,
                  ];
                });
            }
          });
      } else {
        // salvataggio in caso di edit
        const editUrl = `${apiAllestimentiUrl}/${this.allestimentiActiveId}`;
        // qui devo fare caricamento dati ma non include i file da gestire con upload
        useJwt
          .patch(editUrl, this.allestimentiActiveData)
          .then((res) => {
            if (res.status == 200 || res.status == 201) {
              this.makeToast(
              "primary",
              "Successo",
              "Modifica dell'allestimento"
              );
            }
            console.log(res.status);
            return this; // restituisci contesto per permettere aggiornamento gridA
          })
          .then((context) => {
            const datiDaInviare = {
              spettacolo: this.spettacoloCorrente,
            };
            if (datiDaInviare.spettacolo === null) {
              console.log("Spettacolo non ancora selezionato");
            } else {
              useJwt
                .post(apiAllestimentoRicercaUrl, datiDaInviare)
                .then((d) => {
                  // gestione risposta
                  console.log(
              "Aggiornamento gridA con la modifica di una scrittura"
                  );
                  console.log(d.data);
                  context.allestimentiFullData = d.data;
                  context.allestimentiFullData = [
                    ...context.allestimentiFullData,
                  ];
                });
            }
          });
      }
      this.$refs.dialogA1.hide();
      // triggerare aggiornamento filtering / ordinamento? <----------------------
    },
    dialogA1Cancel() {
      console.log("Cliccato bottone Cancel di dialogA1");
      this.$refs.dialogA1.hide();
    },
    // per gridA
    gridAClickHandler(args) {
      // pulsante NEW
      if (args.item.id === "new") {
        this.dialogA1.header = "Nuovo Allestimento";
        // ZZZ
        this.allestimentiDefaultData = {
          id: 0,
          spettacolo: this.spettacoloCorrente,
          descrizione: null,
          categoria: null,
          importo: null,
          percentualeCompetenza: 100,
          note: null,
          fornitore: null,
          dataScadenzaPagamento: null,
          pagato: null,
          dataPagamento: null,
          dataPagamentoPrevista: null,
          riferimentoContabile: null,
          noteContabili: null,
          importoConsuntivo: null,
          numRegistrContabile: null,
          contoContabile: null,
          descrContoContabile: null,
        };
        this.allestimentiActiveData = this.allestimentiDefaultData;
        console.log("Premuto pulsante creazione nuovo allestimento da gridA");
        this.allestimentiActiveId = 0;
        this.$refs.dialogA1.show(true);
      }
      // pulsante EDIT
      else if (args.item.id === "edit") {
        this.dialogA1.header = "Modifica Allestimento";
        console.log("Premuto pulsante modifica allestimento da gridA");
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          let found = false;
          this.allestimentiActiveId = selectedRow[0].id;
          // console.log("gridA, Id selezionato:");
          console.log(this.allestimentiActiveId);
          for (const i in this.allestimentiFullData) {
            if (this.allestimentiFullData[i].id === this.allestimentiActiveId) {
              // console.log("id dell'elenco trovato:")
              // console.log('allestimento corrente')
              // console.log(this.allestimentiFullData[i])
              this.allestimentiActiveData = { ...this.allestimentiFullData[i] };
              if (this.allestimentiActiveData.dataScadenzaPagamento) {
                const tmp =
                  this.allestimentiActiveData.dataScadenzaPagamento.split(
              "T"
                  )[0];
                const d = new Date(tmp);
                this.allestimentiActiveData.dataScadenzaPagamento = d;
              }
              if (this.allestimentiActiveData.dataPagamento) {
                const tmp1 =
                  this.allestimentiActiveData.dataPagamento.split("T")[0];
                const d1 = new Date(tmp1);
                this.allestimentiActiveData.dataPagamento = d1;
              }
              found = true;
              break;
            }
          }
          console.log("allestimento corrente");
          console.log(this.allestimentiActiveData);
          console.log(this.allestimentiActiveId);

          if (found) {
            // allestimento
            console.log("Edit allestimento");
            this.$refs.dialogA1.show(true);
          } else {
            console.log("Elemento non trovato");
          }
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      }
      // Pulsante DELETE
      else if (args.item.id === "delete") {
        try {
          console.log("Premuto pulsante elimina allestimento da gridA");
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          const deletedElementId = selectedRow[0].id;

          const deleteUrl = `${apiAllestimentiUrl}/${deletedElementId}`;
          this.$refs.gridA.ej2Instances.deleteRecord();

          useJwt.delete(deleteUrl).then((res) => {
            console.log("Eliminazione avvenuta con successo");
            // console.log(res.data)
          });
        } catch (err) {
          // da sistemare..............
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      }
    },
    gridAactionBegin(e) {
      if (!this.gridAFlag) {
        // Add and edit operations
        if (e.requestType === "save") {
          const editedData = e.data;
          console.log(editedData);
          // The default edit operation is cancelled
          e.cancel = true;
          const editUrl = `${apiAllestimentiUrl}/${editedData.id}`;
          useJwt.patch(editUrl, editedData).then((res) => {
            console.log(res);
            if (res.status === 200) {
              // se tutto OK
              // Flag is enabled to skip this execution when grid ends add/edit
              this.gridAFlag = true;
              // If your data is updated at the server side successfully, we can call the grid endEdit() method to save the edited data to the Grid
              this.$refs.gridA.endEdit();
            } else {
              this.makeToast(
        "primary",
        "Attenzione",
        "Salvataggio allestimento non riuscito"
              );
            }
          });
        }
      }
    },
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridAactionComplete(e) {
      if (e.requestType === "save") {
        // The flag is disabled after operation is successfully performed so that it can enter the condition on next execution
        this.gridAFlag = false;
      }
    },
    // per salvare allestimento al momento del passaggio ad un altro tab (o in caso di pressione del tasto OK <- MI SEMBRA CHE NON LO USI QUI)
    salvaSoggetto() {
      // console.log('-- salvaSoggetto-- ')
            if (this.allestimentiActiveId !== 0) {
        if (this.hasChanged) {
          // salva su remoto solo se form cambiata
          // se info modificate
          console.log("-- salvaSoggetto salva edit-- ");
          const editUrl = `${apiAllestimentiUrl}/${this.allestimentiActiveId}`;
          useJwt.patch(editUrl, this.allestimentiActiveData).then((res) => {
            console.log(res.status);
            console.log(res.data);
          });
        } else {
          console.log("nessuna modifica");
        }
      } else {
        console.log("-- salvaSoggetto salva nuovo-- ");
        console.log(this.allestimentiActiveData);

        useJwt
          .post(apiAllestimentiUrl, this.allestimentiActiveData)
          .then((res) => {
            console.log(res.status);
            console.log(res.data);
            this.allestimentiActiveId = res.data.id;
            this.allestimentiActiveData.id = res.data.id;
          });
      }
    },

    // per click tabs
    tabClicked(args) {
      switch (args) {
        case "dialogA1Tab01":
          console.log("Sei nel primo tab del dialogA1");
          break;
        case "dialogA1Tab02":
          console.log("Sei nel secondo tab del dialogA1");
          //this.salvaSoggetto()
          break;
        default:
          console.log(args);
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      });
    },
    noop() {
      console.log("premuto enter");
          },
        },
        computed: {
    hasChanged() {
      // console.log(this.allestimentiActiveData)
      // console.log(this.allestimentiSavedData)
      return Object.keys(this.allestimentiActiveData).some(
        (field) =>
          this.allestimentiActiveData[field] !==
          this.allestimentiSavedData[field]
      );
    },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-vue-richtexteditor/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}
</style>
